module.exports = __webpack_public_path__ + "img/EXTERIOR-SWIFT-SPORT-4.3b94704f.jpg";